import { render } from "./comCartView.vue?vue&type=template&id=2a0e023a"
import script from "./comCartView.vue?vue&type=script&lang=js"
export * from "./comCartView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__